import { ILeads } from "interfaces";

export const UPDATE_BUDGET_STATUS_LABEL = "Atualizar status SIGO";

export const UPDATE_BUDGET_STATUS_SUCCESS_MESSAGE =
  "Status SIGO atualizado com sucesso.";

export const UPDATE_BUDGET_STATUS_ALREADY_SYNCED_MESSAGE =
  "Status do budget já estava sincronizado com o SIGO.";

export const UPDATE_BUDGET_STATUS_ERROR_MESSAGE =
  "Não foi possível atualizar o status SIGO.";

export type UpdateBudgetStatusLead = Partial<ILeads> & {
  budget_number?: string;
  health_insurer_name?: string;
  branch_code?: string;
  friendly_plan_name?: string;
  ans_code?: string;
  payment_date?: string;
  bill_emission_date?: string;
};

export type UpdateBudgetStatusResponse = {
  budgetId: string;
  controlNumber: string;
  statusBefore: number;
  statusAfter: number;
  updated: boolean;
  detail?: string;
  lead?: UpdateBudgetStatusLead;
};

export const normalizeControlNumber = (
  controlNumber?: string | number | null,
): string | null => {
  if (controlNumber === null || controlNumber === undefined) {
    return null;
  }

  const normalized = String(controlNumber).trim();
  return normalized.length > 0 ? normalized : null;
};

export const hasValidControlNumber = (
  controlNumber?: string | number | null,
): boolean => normalizeControlNumber(controlNumber) !== null;

export const buildUpdateBudgetStatusPath = (
  controlNumber: string | number,
): string => {
  const normalized = normalizeControlNumber(controlNumber);

  if (!normalized) {
    return "";
  }

  return `/v2/budget/control/${encodeURIComponent(normalized)}/refresh-status`;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === "object";

const isUpdateBudgetStatusResponse = (
  value: unknown,
): value is UpdateBudgetStatusResponse =>
  isRecord(value) &&
  typeof value.budgetId === "string" &&
  typeof value.controlNumber === "string" &&
  typeof value.statusBefore === "number" &&
  typeof value.statusAfter === "number" &&
  typeof value.updated === "boolean";

export const unwrapUpdateBudgetStatusResponse = (
  response?: unknown,
): UpdateBudgetStatusResponse | undefined => {
  if (isUpdateBudgetStatusResponse(response)) {
    return response;
  }

  if (isRecord(response) && isUpdateBudgetStatusResponse(response.data)) {
    return response.data;
  }

  return undefined;
};

export const getUpdateBudgetStatusSuccessMessage = (
  response?: UpdateBudgetStatusResponse,
): string => {
  if (response?.detail) {
    return response.detail;
  }

  if (response?.updated === false) {
    return UPDATE_BUDGET_STATUS_ALREADY_SYNCED_MESSAGE;
  }

  return UPDATE_BUDGET_STATUS_SUCCESS_MESSAGE;
};

export const getUpdateBudgetStatusErrorMessage = (): string =>
  UPDATE_BUDGET_STATUS_ERROR_MESSAGE;
